
import Vue from "vue";
import { SessionService } from "@/features/Authentication/SessionService";

export default {
    async mounted() {
        // This component just serves as a way for the router to block access to pages
        // and kick off the login workflow
        var sessionService: SessionService = Vue.prototype.$sessionService;
        await sessionService.login();
    },
};
